import { useMemo } from 'react'
import { FLOOR_PLAN_COLORS } from '../components/viewer/2D/Elements'

interface CustomColors {
  normal?: string
  selected?: string
  hover?: string
}

export interface ElementStyling {
  fill: string
  stroke: string
  strokeWidth: number
  opacity: number
  cursor?: string
}

export const useElementStyling = (
  isSelected: boolean,
  isHovered: boolean,
  customColors?: CustomColors,
): ElementStyling => {
  return useMemo(() => {
    const baseColors = {
      normal: customColors?.normal || FLOOR_PLAN_COLORS.WALLS,
      selected: customColors?.selected || FLOOR_PLAN_COLORS.SELECTED,
      hover: customColors?.hover || FLOOR_PLAN_COLORS.HOVER,
    }

    let fill = baseColors.normal
    let stroke = '#000000'
    let strokeWidth = 0

    if (isSelected) {
      fill = baseColors.selected
    } else if (isHovered) {
      fill = baseColors.hover
    }

    return {
      fill,
      stroke,
      strokeWidth,
      opacity: 1,
      cursor: isSelected ? 'move' : 'pointer',
    }
  }, [isSelected, isHovered, customColors])
}
